import React from "react";
import PropTypes from "prop-types";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import "./styles.scss";
import SnackbarContainer from "./SnackbarContainer";
import { ENTER_AND_EXIT_TIMEOUT } from "./constants";

const Snackbars = ({ snackbars, onRequestHide, displayTime }) => (
  <div className="mydpd-snackbars-container">
    <TransitionGroup>
      {snackbars.map(snackbar => {
        const localDisplayTime = snackbar.displayTime; // It's optional snackbar parameter. It has highest priority.
        return (
          <CSSTransition
            key={snackbar.id}
            classNames="snackbar-container"
            timeout={ENTER_AND_EXIT_TIMEOUT}
          >
            <SnackbarContainer
              key={snackbar.id}
              type={snackbar.type}
              message={snackbar.message}
              onRequestHide={() => onRequestHide(snackbar.id)}
              displayTime={localDisplayTime || displayTime}
            />
          </CSSTransition>
        );
      })}
    </TransitionGroup>
  </div>
);

Snackbars.propTypes = {
  snackbars: PropTypes.array.isRequired,
  onRequestHide: PropTypes.func.isRequired,
  displayTime: PropTypes.number.isRequired,
};

export default Snackbars;
